import React from 'react';

export const MinusGray300Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 10.8317H4.99996C4.77895 10.8317 4.56698 10.7439 4.4107 10.5876C4.25442 10.4313 4.16663 10.2194 4.16663 9.99837C4.16663 9.77736 4.25442 9.5654 4.4107 9.40912C4.56698 9.25284 4.77895 9.16504 4.99996 9.16504H15C15.221 9.16504 15.4329 9.25284 15.5892 9.40912C15.7455 9.5654 15.8333 9.77736 15.8333 9.99837C15.8333 10.2194 15.7455 10.4313 15.5892 10.5876C15.4329 10.7439 15.221 10.8317 15 10.8317Z"
        fill="#DCDCDC"
      />
    </svg>
  );
};
